import { TicketHolderFormField } from '@domain/ticket-holder-form-field';
import { isCollectedFormField } from '@utils/collected-form-fields/is-collected-form-field';

export const hasTicketHolderFormFields = (fields: TicketHolderFormField[]) => {
  return fields.some(isCollectedFormField);
};
